import request from '@/utils/request'
import type { ApiResponse } from '@/types/menu'
import { ElMessage } from 'element-plus'
import { getStandardById } from './menu'

export function getLevelDetail(id: string, level: number) {
  if (!id || typeof level !== 'number') {
    return Promise.reject(new Error('指标参数不完整'))
  }
  
  return request({
    url: `/admin/level/${id}`,
    method: 'get',
    params: {
      level
    },
    validateStatus: function (status) {
      return status >= 200 && status < 300
    }
  })
}

// Add this new function
export function addLevel(data: {
  content?: string;
  ifNextLevel?: number;
  imageList?: string[];
  level: number;
  name: string;
  numId: string;
  standardId: number;
}) 
{
  return request({
    url: '/admin/level',
    method: 'post',
    data
  })
}

// 在类型定义文件中添加
export interface LevelUpdateRequest {
  id: number;
  standardId: number;
  level: number;
  numId: string;
  name: string;
  content?: string;
  ifNextLevel?: number;
  imageList?: string[];
}

// 修改API函数签名
export const updateLevel = (data: LevelUpdateRequest): Promise<ApiResponse> => {
  return request({
    url: '/admin/level',
    method: 'PUT',
    data
  });
};

// 修改删除接口
export const deleteLevel = (params: { id: string; level: number; numId: string }) => {
  if (!params.id || !params.level || !params.numId) {
    return Promise.reject(new Error('删除操作缺少必要参数'));
  }
  
  return request({
    url: `/admin/level/${params.id}`,
    method: 'DELETE',
    params: {
      level: params.level,
      numId: params.numId
    }
  });
};
interface InsertRequest {
  standardId: number
  level: number
  numId: string // 被插入位置的numId
  name: string
  content?: string
  imageList?: string[]
  ifNextLevel?: number
}

// 指标插入
export function insertLevel(data: InsertRequest) {
  return request<ApiResponse<any>>({
    url: '/admin/level/insert',
    method: 'post',
    data
  })
  }

  export interface Request {
    level?: string;
    numId?: string;
    standardId?: string;
    [property: string]: any;
}

export function searchLevelDetail(data:Request) { 
    return request({
      url: `/admin/level/select`,
      method: 'get',
      params: data
})
  }